import TemplateSetting from "./TemplateSetting.vue";
import TemplateSettingAdd from "./TemplateSettingAdd.vue";
import TemplateSettingDetail from "./TemplateSettingDetail.vue";
import TemplateSettingEdit from "./TemplateSettingEdit.vue";

let routesTemplateSetting= [
    {
        path: '',
        meta: {
            title: "Chain System",
        },
        name: "TemplateSetting",
        component: TemplateSetting
    },
    {
     path: 'add',
        meta: {
            title: "Chain System",
        },
        name: "TemplateSettingAdd",
        component: TemplateSettingAdd
    },
    {
     path: 'detail/:id',
        meta: {
            title: "Chain System",
        },
        name: "TemplateSettingDetail",
        component: TemplateSettingDetail
    },
    {
     path: 'edit/:id',
        meta: {
            title: "Chain System",
        },
        name: "TemplateSettingEdit",
        component: TemplateSettingEdit
    }
]

export default routesTemplateSetting
  